import React from 'react';
import { globalHistory } from '@reach/router';
import BreadcrumbData from './breadcrumbdata.json';
import CustomImage from '../custom-image';
import { Link } from 'gatsby';

const BreadCrumb = () => {
  let currentPage = globalHistory.location.pathname;
  currentPage =
    currentPage.charAt(currentPage.length - 1) === '/' ? currentPage.substring(0, currentPage.length - 1) : currentPage;
  const breadcrumb = BreadcrumbData[currentPage];
  const renderBreadcrumb = () => {
    return breadcrumb.map((item, index) => {
      return item.icon ? (
        <Link to={item.link} key={index}>
          <CustomImage className="icon-arrow-up" imageName={item.icon} alt={`Icon-${item.name}`} maxWidth="13" />
        </Link>
      ) : (
        <div key={index}>
          <CustomImage
            className="icon-arrow-up"
            imageName="icon-right-carrot-white.svg"
            alt="Icon right carrot"
            maxWidth="10"
          />
          <Link to={item.link}>{item.name}</Link>
        </div>
      );
    });
  };

  return (
    <div>
      {breadcrumb && (
        <div className="breadcrumb-container">
          <div className="page-breadcrumbs">{renderBreadcrumb()}</div>
        </div>
      )}
    </div>
  );
};

export default BreadCrumb;
